module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-03.430bd820.jpg";